import React from 'react';

const SettingsButton = (props) => (
  <div
    className={props.className}
    onClick={props.onClick}
    disabled={props.disabled}
  >
    <span>
      Change
      <br />
      {props.btnName}
    </span>
  </div>
);
export default SettingsButton;
